import GraphContainer from "./graph_container";

function createTextFilter(uuid) {
    const feFlood = GraphContainer
        .create("feFlood")
        .setAttribute("flood-color", "white")
        .setAttribute("result", "floodOut");

    const feComposite = GraphContainer
        .create("feComposite")
        .setAttribute("in", "floodOut")
        .setAttribute("in2", "SourceGraphic")
        .setAttribute("operator", "in")
        .setAttribute("result", "compOut");

    const feOffset = GraphContainer
        .create("feOffset")
        .setAttribute("in", "compOut")
        .setAttribute("result", "offOut")
        .setAttribute("dx", "1")
        .setAttribute("dy", "1");

    const feBlend = GraphContainer
        .create("feBlend")
        .setAttribute("in", "SourceGraphic")
        .setAttribute("in2", "offOut")
        .setAttribute("mode", "normal");

    const filter = GraphContainer
        .create("filter")
        .setAttribute("x", 0)
        .setAttribute("y", 0)
        .setAttribute("width", "200%")
        .setAttribute("height", "200%")
        .setAttribute("id", `fill_text_${uuid}`)
        .append(feFlood, feComposite, feOffset, feBlend);

    return { feFlood, feComposite, feOffset, feBlend, filter };
}

export default createTextFilter;
export { createTextFilter };